import { render, staticRenderFns } from "./OlocConfirmationScreen.vue?vue&type=template&id=7c206a12&scoped=true"
import script from "./OlocConfirmationScreen.vue?vue&type=script&lang=js"
export * from "./OlocConfirmationScreen.vue?vue&type=script&lang=js"
import style0 from "./OlocConfirmationScreen.vue?vue&type=style&index=0&id=7c206a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c206a12",
  null
  
)

export default component.exports